import { type ReactNode } from 'react';
import { cn } from '@shared/lib/cn';

/**
 * Page wrapper. Handles default screen gutters (24px), top/bottom safe-area
 * padding, and a `scroll` flag that lets the page own its own scroll
 * container (most pages do; sheets and panic SOS opt out).
 */
interface PageProps {
  children: ReactNode;
  className?: string;
  /** When true, page itself scrolls. Default true. Set false for fullscreen UI like SOS. */
  scroll?: boolean;
  /** When true, omit horizontal gutters (caller paints full-bleed sections). */
  bleed?: boolean;
}

export function Page({ children, className, scroll = true, bleed = false }: PageProps): JSX.Element {
  return (
    <div
      className={cn(
        'relative min-h-full bg-paper text-ink',
        scroll ? 'overflow-y-auto overscroll-y-none' : 'overflow-hidden',
        !bleed && 'px-6',
        'pt-safe-or-6 pb-safe-or-6',
        className,
      )}
    >
      {children}
    </div>
  );
}
